import Player from './player'
import * as Controls from './control/*.js'
import './style/index.scss'
export default Player
